import React, { useState } from "react";
import "./schedule.css";

const ScheduleSection = () => {
  const [activeDay, setActiveDay] = useState("Day 1");

  const dayDateMap: any = {
    "Day 1": "13 November 2025",
    "Day 2": "14 November 2025",
    "Day 3": "15 November 2025",
  };

  const schedule: Record<
    string,
    Array<{
      time: string;
      topic: string;
      speaker?: string[];
      moderator?: string[];
      about?: string[];
      venue?: string[];
      location?: string[];
      fireside?: string[];
      link?: string;
    }>
  > = {
    "Day 1": [
      {
        time: "12:00 - 18:00",
        topic: "Registration",
      },
      {
        time: "18:00 - 21:00",
        topic: "Cocktail Reception; Dress Code: Smart Casual",
        venue: ["Bliss 6 | Conrad Dubai"],
        link: "https://maps.app.goo.gl/dFXeo2iuZEpN6cTG8",
      },
    ],
    "Day 2": [
      {
        time: "08:30 - 09:30",
        topic: "Registration - Networking",
      },
      {
        time: "09:30 - 10:00",
        topic: "Official Inauguration and Opening Speeches",
        speaker: [
          "09:30 - 09:35 (5mins) - H.H. Sheikh Mohammed bin Maktoum bin Juma Al Maktoum - Honorary Chairman of UAE Financial Markets Association",
          "09:35 - 09:40 (5mins) - Mohammed Al Hashemi - President of UAE Financial Markets Association",
          "09:40 - 09:45 (5mins) - Abdulla Dawood - Chairman of ICA",
          "09:45 – 10:00 (15mins) - Dr. Mahmoud Mohieldin - UN Special Envoy on Financing Sustainable Development Development",
        ],
        about: [""],
      },
      {
        time: "10:00 - 10:50",
        topic:
          "Keynote speaker - Introductory comments on a “world of uncertainty.”",
        speaker: [
          "Dr. Mark Mobius - Chairman, Mobius Emerging Opportunities Fund",
        ],
        fireside: ["Mr. Chavan Bhogaita - Markets Professional"],
        about: [
          "The relatively stable world order of the post-Cold War years is being fundamentally challenged and profoundly reshaped by multiple factors.",
          "   • Global growth dynamics have weakened and there has been a broad-based downtrend in productivity growth. This has eroded living standards and led to growing economic challenges in many poorer countries, driving several of them to effectively failed states.",
          "   • The growing income and wealth differentials, further exacerbated by the global financial crisis, have cast a long shadow of popular discontent and social marginalization. This has, among other things, eroded social and political cohesion, leading to a rise of protest movements, populist politics, but also violent activism.",
          "   • Involuntary migration has increased, causing controversy, despite an advancing demographic transition worldwide. This has fueled multiple efforts to limit global mobility while leaving many countries grappling with growing talent shortages.",
          "   • The ethos of globalization is decisively in retreat with a growing number of governments ready to impose trade restrictions in a bid to claw back jobs and investment. Concurrently, competition has intensified for strategic resources, and growing prioritization of security considerations to protect supply chains has become more evident through localization and initiatives such as near-shoring and friend-shoring.",
          "   • The “New World Order” of the post-Cold War era, led by one hegemon, has given way to a multi-polar world and growing power rivalry amid increasingly blatant efforts by some countries to project their global influence. Tensions between China and the West have been mounting for years while Russia’s aggression in Ukraine was followed by multiple sanctions that pushed Moscow to align more closely with several Asian countries.",
          "   • Technological change is accelerating and becoming increasingly transformative. The advancing adoption of digital technology is giving rise to new forms of connectivity and data utilization. Landmark technologies such as generative AI and quantum computing have repositioned technology as a growth driver. However, there are also many unanswered questions about the impact of technology on jobs, skills, and learning. Similarly, technology is causing new vulnerabilities, eg cybercrime, while potentially giving rise to capacities and risks that are yet to be understood. Fears of a new dotcom bubble have also infected a once unshakeable investor sentiment.",
          "   • Climate change is showing signs of accelerating and is creating new challenges to economic and social activity. The debates between mitigation and adaption are ever-changing while many countries are seeing growing political resistance to the green energy transition.",
        ],
      },
      {
        time: "10:50 - 11:40",
        topic:
          "Panel 1: Repositioning the Middle East in a world of uncertainty",
        moderator: [
          "Rania Younes - Sr. Radio Presenter, Dynamic Emcee, Inspiring Motivator & Art of Public Address Expert",
        ],
        speaker: [
          "H.E Raja Al Mazrouei - Chief Executive Officer, Etihad Credit Insurance",
          "Toby Iles - Jadwa’s Chief Economist and a member of the Executive Management Committee",
          "Dr. Jarmo Kotilaine - Strategic Advisor & Author",
          "Ahmed Nassef - Group COO, Dopay",
        ],
        about: [
          "The leading Middle Eastern economies are highly open and dependent on foreign trade and investment. This represents a major vulnerability in a fragmenting world.",
          "All the Arab countries face significant challenges and opportunities in safeguarding their economies and growth strategies. Important government initiatives are underway across the region to build resilience in the face of these challenges. These include:",
          "   • Local capacity-building through structured economic diversification and efforts to expand local value chains.",
          "   • Most key countries have adopted strategic neutrality, which seeks to build relations in multiple directions in a non-exclusionary manner.",
          "   • Regional integration has received some renewed impetus, especially from Gulf countries who have recognized the importance of engaging with neighboring geographies by boosting connectivity and reaping complementarities instead of merely seeking to contain security risks and reinforce the GCC’s “safe haven” status. Key Gulf institutional investors are mobilizing capital across the Middle East while new linkages are emerging, for instance, through power grid connectivity. Even traditionally tense relations, such as between the Gulf and Iran, appear to be moving in a more pragmatic direction. There has, similarly, been a rapprochement between the GCC and Turkey.",
          "   • The Middle East is emerging as a major producer of, and investor in, clean energy. This allows it to capitalize on its location and improving connectivity while future proofing its energy sector. A testament to this is Egypt’s Benban Solar Park, which is one of the largest solar installations globally, with a total capacity of 1.65 GW.",
          "What role is the financial sector playing in enabling and accelerating these changes? How can we enhance this role and make finance a key enabler of change?",
        ],
      },
      {
        time: "12:10 - 13:00",
        topic: "What is the future of deglobalization?",
        speaker: [
          "Augusto Lopez Claros – Executive Director of the Global Governance Forum",
        ],
        about: [
          "Forward-looking analysis of the drivers of economic (and political) fragmentation over the next decade. How could events evolve and what are the implications?",
        ],
      },
      {
        time: "13:00 - 13:50",
        topic:
          "Panel 2: How to make the most of the exceptional location of the Middle East?",
        moderator: [
          "Mina Nasif - CTP Corporate Treasury & Investment Consultant",
        ],
        speaker: [
          "Simon Williams – Economist for MENA, HSBC",
          "Farouk Soussa - Middle East and North Africa economist within the CEEMEA economics team at Goldman Sachs",
          "Karim Adouane - Head of Global Markets Trading, Ajman Bank",
        ],
        about: [
          "   • Most key countries have adopted strategic neutrality, which seeks to build multiple non-exclusionary relations.",
          "   • The region is looking to further capitalize on its exceptional location by boosting linkages in multiple directions across a range of facets. The Gulf countries are leading in major investments in aviation and port capacity. Other initiatives include the capacity expansion of the Suez Canal and the Iraq Development Road project, which has gained traction amid security challenges in the Red Sea.",
          "   • How to attract and retain talent that can boost the region’s standing and productivity? How to compete in an ageing world?",
          "   • How to make regulation a true competitiveness driver?",
          "   • How to capture and integrate into value chains?",
          "   • How to make the region a global financial hub?",
        ],
      },
      {
        time: "14:00 - 15:00",
        topic: "Business Lunch",
      },
      {
        time: "15:00 - 15:50",
        topic:
          "Panel 3: Bond trading and market structure – the quiet revolution",
        moderator: [
          "Andy Hill - Managing Director, Co-Head of Market Practice & Regulatory Policy, ICMA",
        ],
        speaker: [
          "Dr. Anita Yadav - CEO, Global Credit Advisory",
          "Sylvain Bigaud - Senior Executive Officer & Regional Head – MEAT, Euroclear Bank",
          "Tahir Aslam - Head of Fixed Income Trading, Global Markets, FAB",
          "Zeina Rizk - Co-Head of Fixed Income and Partner, Amwal Capital Partners",
        ],
        about: [
          "Key questions:",
          "   • What are the dynamics that are re-shaping secondary bond market structure?",
          "   • How are data and technology being harnessed to create liquidity?",
          "   • What are the implications for bond market participants?",
          "Key themes:",
          "   • The growth of bond markets and diminishing dealer capacity",
          "   • More and better data and computational power",
          "   • New products and entrants",
        ],
      },
      {
        time: "15:50 - 16:45",
        topic: "Panel 4: The role of repo in bond market development",
        moderator: [
          "Sanaa Clausse BenAbdelhadi - Sr. Director & Head of Business Development, ICMA",
        ],
        speaker: [
          "Andrew Stephen - Exec. Director, Buyside Trading Services Sales, JPMorgan Chase",
          "Muhammed Yasir Gorpe - Sr. Investment Specialist - Fund Manager, Liquidity Investments, Treasury Department, Islamic Development Bank",
          "Omar El Adel - Head of Treasury and Financial Institutions at Arab African International Bank",
          "Muneeb Azhar - Director, Funding Centre, Treasury and Global Markets, Mashreq",
        ],
        about: [
          "Key questions:",
          "   • In what ways can the repo market be used, by whom, and why is it so important?",
          "   • From pre-trade to post-trade, what are the key considerations for an efficient and liquid market?",
          "   • What are the similarities and differences between Islamic and conventional repo?",
          "Key themes:",
          "   • The interconnectedness of repo, bond, money, and derivatives markets",
          "   • Legal, regulatory, and market structures to support repo trading",
          "   • The development of Islamic repo",
        ],
      },
      {
        time: "17:00",
        topic: "ICA Board meeting",
        speaker: [],
        about: [],
      },
      {
        time: "18:00 - 19:00",
        topic: "Gala Dinner Venue Transportation",
        speaker: [],
        about: [],
      },
      {
        time: "19:00 - 20:00",
        topic: "Gala Dinner Reception & Networking",
        speaker: [],
        about: [],
      },
      {
        time: "20:00 - 22:30",
        topic: "Gala dinner – Dress code: formal",
        speaker: [],
        about: [],
        venue: ["The Address Montgomerie"],
        location: ["Emirates Hills PO Box 36700, Emirates Hills, Dubai"],
      },
    ],
    "Day 3": [
      {
        time: "09:00 - 10:00",
        topic: "Networking Reception",
        speaker: [],
        about: [],
      },
      {
        time: "10:00 - 10:50",
        topic: "Global Economic Outlook",
        speaker: [
          "Sony Kapoor - an influential macroeconomist, geostrategist, and investment expert who advises several G-20 and EU governments, large institutional investors, international organizations, and multinational companies",
        ],
        about: [],
      },
      {
        time: "10:50 - 11:40",
        topic:
          "Panel 5: Future of technology; How is technology reshaping financial services?",
        moderator: ["Paul Chalmers - CEO of UK Trading Academy"],
        speaker: [
          "Fawaz Ghazal - CEO of Flooss Bahrain BSC, the first digital lending company in the Kingdom of Bahrain",
          "Avramis Despotis - Founder and CEO, Tradepedia",
          "Prof. Uwe Wystup - Professor, Expert in FX options, pricing, and risk management",
          "Ben Humphreys - Head of Data Engineering, Parameta Solutions (TPICAP Group)",
        ],
        about: [
          "   • What is driving technological innovation and how do we expect it to reshape the world over the coming decade?",
          "   • What are the key transformative technologies? How strategically are we thinking about them? What are the potential benefits and risks?",
          "   • Inclusion",
          "   • Productivity",
          "   • Transparency",
          "   • Tradability",
          "   • Impact",
          "   • Tokenization",
          "   • Vulnerability",
        ],
      },

      { time: "11:40 - 12:10", topic: "Coffee Break & Exhibition" },
      {
        time: "12:10 - 13:00",
        topic: "How healthy is the global financial system?",
        speaker: [
          "Danilo McGarry – Recognized as one of the Top 20 in the World for AI, CEO of AI First Maker (AFM)",
        ],
        about: [
          "A decade and a half after the Global Financial Crisis, a multitude of changes are raising renewed questions about the health of the global financial system.",
          "   • There has been a systematic increase in leverage, especially in the case of sovereigns. The post-COVID departure from prolonged historically low interest rates is dramatically pushing up the cost of servicing debts.",
          "   • Disintermediation is now more evident. Private credit is growing rapidly and there is increasing evidence of its connections with the banking system and with institutional investors. Private credit funds are exposed to credit risk, leverage and liquidity vulnerabilities, but their opacity makes it difficult to assess them.",
          "   • The supply of especially commercial real estate has grown dramatically in recent years, only to be challenged by technological disruptions and the increased cost of leverage. There is growing concern of systemic financial stability risks this might create.",
          "   • Rising geopolitical tensions threaten to fragment the global financial system pushing up costs and risks.",
          "   • Asset valuations remain elevated, and markets are often highly sensitive to disruptions.",
          "   • The growing adoption of digital technology has left systems increasingly vulnerable to cyber-attacks with risk management often lagging behind other changes.",
          "   • Climate change and the energy transition entail new risks, whether in terms of the costs of major events, the challenges to insurance, or the problems associated with carbon trading.",
        ],
      },
      {
        time: "13:00 - 13:50",
        topic: "Panel 6: Future Developments of the Global Currency System",
        moderator: ["Rui Correia - CEO & Chair of Board of Education, ACI FMA"],
        speaker: [
          "Paul Blustein - Award-winning Economic Journalist",
          "Nameer Khan - Chairman, MENA Fintech Association",
          "Dr. Tom James - CEO & CIO, Trade Flow Funds",
          "James Kemp - Managing Director of the GFMA’s Global FX Division",
        ],
        about: [
          "The prospects for the US Dollar’s survival as the world’s prominent reserve currency has been debated for years. However, in a world where the traditional hegemony of the US is gradually waning, the share of the Dollar in global reserves has been gradually, but consistently declining.",
          "Having stood at over 70% at the beginning of the millennium, the share of the Dollar has fallen below the 60% mark. President Trump recently threatened countries seeking to circumvent the Dollar with punitive tariffs. Nonetheless, there is little reason to believe that the trend will not continue, even if a compelling alternative to the Dollar is yet to emerge.",
          "The decline of the Dollar, despite its recent strength vis-à-vis other currencies, is in large part reflective of the ongoing fragmentation of the global economy. China, which is a major trading nation, has for years made proactive efforts to encourage the utilization of the Renminbi in bilateral trade relations. Even India has taken some initiatives to boost the use of the Rupee.",
          "The imposition of Western sanctions on economies ranging from Russia to Iran and North Korea has effectively excluded countries from the traditional Dollar-based order.",
          "Today, the erosion of the Dollar order does not involve just other currencies. Anxiety about global economic and financial stability, along with the growing perception of political risk, have driven a major revival of interest in gold with many economies actively seeking to boost their gold reserves.",
          "Similarly, the rapid evolution of financial technology is giving rise to new kinds of crypto assets and stable coins that can be used for trading in a variety of ways. Some countries have begun to accept crypto assets for their official reserves. Trading in stable coins potentially offers greater flexibility in a fragmenting global economy while allowing entities to escape the Dollar-finance-linked oversight of the US Department of Justice.",
        ],
      },
      {
        time: "14:00 - 15:00",
        topic: "Business Lunch",
        speaker: [],
        about: [],
      },
      {
        time: "15:00",
        topic: "ICA General Assembly",
        speaker: [],
        about: [],
      },
      {
        time: "17:30 - 21:00",
        topic: "Dinner – Dress code: Smart casual",
        speaker: [],
        about: [],
        venue: ["The Theatre Dubai | Fairmont Hotel"],
        link: "https://maps.app.goo.gl/ykpNMpP18Lva5Pi37",
      },
    ],
  };

  return (
    <section id="agenda" className="schedule pt-120 pb-120">
      <div className="container">
        <div className="row">
          <div className="col-sm-8 col-sm-offset-2 mb-100 text-center">
            <h1 className="title">Agenda</h1>
            <p className="title-lead mt-10">
              Discover a dynamic lineup of sessions designed to inspire,
              educate, and connect.
            </p>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-sm-4">
            <ul className="block-tabs">
              {Object.keys(schedule).map((day) => (
                <li
                  key={day}
                  className={`tab-item ${activeDay === day ? "active" : ""}`}
                  onClick={() => setActiveDay(day)}
                >
                  <div className="block-info-1 et-line-calendar">
                    <svg
                      version="1.1"
                      id="Layer_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      width="25px"
                      height="20px"
                      viewBox="0 0 42 32"
                      enable-background="new 0 0 42 32"
                      xmlSpace="preserve"
                    >
                      <linearGradient
                        id="SVGID_1_"
                        gradientUnits="userSpaceOnUse"
                        x1="5.1983"
                        y1="28.1187"
                        x2="43.4067"
                        y2="11.702"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_1_)"
                        d="M38,30.5v-19c0-0.276-0.224-0.5-0.5-0.5S37,11.224,37,11.5v19c0,0.276-0.224,0.5-0.5,0.5h-31
                              C5.224,31,5,30.776,5,30.5v-19C5,11.224,4.776,11,4.5,11S4,11.224,4,11.5v19C4,31.327,4.673,32,5.5,32h31
                              C37.327,32,38,31.327,38,30.5z"
                      />
                      <linearGradient
                        id="SVGID_2_"
                        gradientUnits="userSpaceOnUse"
                        x1="4.7162"
                        y1="26.9965"
                        x2="42.9245"
                        y2="10.5799"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_2_)"
                        d="M8.5,23C8.224,23,8,23.224,8,23.5S8.224,24,8.5,24H10v3.5c0,0.276,0.224,0.5,0.5,0.5
                              s0.5-0.224,0.5-0.5V24h6v3.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V24h6v3.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V24
                              h6v3.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V24h1.5c0.276,0,0.5-0.224,0.5-0.5S33.776,23,33.5,23H32v-5h1.5
                              c0.276,0,0.5-0.224,0.5-0.5S33.776,17,33.5,17H32v-4.5c0-0.276-0.224-0.5-0.5-0.5S31,12.224,31,12.5V17h-6v-4.5
                              c0-0.276-0.224-0.5-0.5-0.5S24,12.224,24,12.5V17h-6v-4.5c0-0.276-0.224-0.5-0.5-0.5S17,12.224,17,12.5V17h-6v-4.5
                              c0-0.276-0.224-0.5-0.5-0.5S10,12.224,10,12.5V17H8.5C8.224,17,8,17.224,8,17.5S8.224,18,8.5,18H10v5H8.5z M31,18v5h-6v-5H31z
                              M24,18v5h-6v-5H24z M11,18h6v5h-6V18z"
                      />
                      <linearGradient
                        id="SVGID_3_"
                        gradientUnits="userSpaceOnUse"
                        x1="-0.4811"
                        y1="14.9003"
                        x2="37.7272"
                        y2="-1.5164"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_3_)"
                        d="M32.5,3h4.25C36.837,3,37,3,37,3.5V8H5V3.5C5,3.224,5.224,3,5.5,3h4C9.776,3,10,2.776,10,2.5
                              S9.776,2,9.5,2h-4C4.673,2,4,2.673,4,3.5v5C4,8.776,4.224,9,4.5,9h33C37.776,9,38,8.776,38,8.5v-5C38,2.394,37.354,2,36.75,2H32.5
                              C32.224,2,32,2.224,32,2.5S32.224,3,32.5,3z"
                      />
                      <linearGradient
                        id="SVGID_4_"
                        gradientUnits="userSpaceOnUse"
                        x1="-1.6311"
                        y1="12.2237"
                        x2="36.5772"
                        y2="-4.1929"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_4_)"
                        d="M26.5,3C26.776,3,27,2.776,27,2.5S26.776,2,26.5,2h-11C15.224,2,15,2.224,15,2.5S15.224,3,15.5,3
                              H26.5z"
                      />
                      <linearGradient
                        id="SVGID_5_"
                        gradientUnits="userSpaceOnUse"
                        x1="-2.9557"
                        y1="9.1407"
                        x2="35.2526"
                        y2="-7.2759"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_5_)"
                        d="M13,4.5v-4C13,0.224,12.776,0,12.5,0S12,0.224,12,0.5v4C12,4.776,12.224,5,12.5,5S13,4.776,13,4.5z"
                      />
                      <linearGradient
                        id="SVGID_6_"
                        gradientUnits="userSpaceOnUse"
                        x1="-0.3065"
                        y1="15.3067"
                        x2="37.9019"
                        y2="-1.11"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_6_)"
                        d="M29.5,5C29.776,5,30,4.776,30,4.5v-4C30,0.224,29.776,0,29.5,0S29,0.224,29,0.5v4
                              C29,4.776,29.224,5,29.5,5z"
                      />
                    </svg>
                    <span style={{ marginLeft: 40 }}>
                      <strong>{day}</strong> <span>- {dayDateMap[day]}</span>
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-sm-8">
            {/* Session list */}
            <ul className="block-tab">
              <li className="active">
                <div className="block-date">
                  <div className="block-info-1 et-line-calendar">
                    <svg
                      version="1.1"
                      id="Layer_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      width="25px"
                      height="20px"
                      viewBox="0 0 42 32"
                      enable-background="new 0 0 42 32"
                      xmlSpace="preserve"
                    >
                      <linearGradient
                        id="SVGID_1_"
                        gradientUnits="userSpaceOnUse"
                        x1="5.1983"
                        y1="28.1187"
                        x2="43.4067"
                        y2="11.702"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_1_)"
                        d="M38,30.5v-19c0-0.276-0.224-0.5-0.5-0.5S37,11.224,37,11.5v19c0,0.276-0.224,0.5-0.5,0.5h-31
                              C5.224,31,5,30.776,5,30.5v-19C5,11.224,4.776,11,4.5,11S4,11.224,4,11.5v19C4,31.327,4.673,32,5.5,32h31
                              C37.327,32,38,31.327,38,30.5z"
                      />
                      <linearGradient
                        id="SVGID_2_"
                        gradientUnits="userSpaceOnUse"
                        x1="4.7162"
                        y1="26.9965"
                        x2="42.9245"
                        y2="10.5799"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_2_)"
                        d="M8.5,23C8.224,23,8,23.224,8,23.5S8.224,24,8.5,24H10v3.5c0,0.276,0.224,0.5,0.5,0.5
                              s0.5-0.224,0.5-0.5V24h6v3.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V24h6v3.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V24
                              h6v3.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V24h1.5c0.276,0,0.5-0.224,0.5-0.5S33.776,23,33.5,23H32v-5h1.5
                              c0.276,0,0.5-0.224,0.5-0.5S33.776,17,33.5,17H32v-4.5c0-0.276-0.224-0.5-0.5-0.5S31,12.224,31,12.5V17h-6v-4.5
                              c0-0.276-0.224-0.5-0.5-0.5S24,12.224,24,12.5V17h-6v-4.5c0-0.276-0.224-0.5-0.5-0.5S17,12.224,17,12.5V17h-6v-4.5
                              c0-0.276-0.224-0.5-0.5-0.5S10,12.224,10,12.5V17H8.5C8.224,17,8,17.224,8,17.5S8.224,18,8.5,18H10v5H8.5z M31,18v5h-6v-5H31z
                              M24,18v5h-6v-5H24z M11,18h6v5h-6V18z"
                      />
                      <linearGradient
                        id="SVGID_3_"
                        gradientUnits="userSpaceOnUse"
                        x1="-0.4811"
                        y1="14.9003"
                        x2="37.7272"
                        y2="-1.5164"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_3_)"
                        d="M32.5,3h4.25C36.837,3,37,3,37,3.5V8H5V3.5C5,3.224,5.224,3,5.5,3h4C9.776,3,10,2.776,10,2.5
                              S9.776,2,9.5,2h-4C4.673,2,4,2.673,4,3.5v5C4,8.776,4.224,9,4.5,9h33C37.776,9,38,8.776,38,8.5v-5C38,2.394,37.354,2,36.75,2H32.5
                              C32.224,2,32,2.224,32,2.5S32.224,3,32.5,3z"
                      />
                      <linearGradient
                        id="SVGID_4_"
                        gradientUnits="userSpaceOnUse"
                        x1="-1.6311"
                        y1="12.2237"
                        x2="36.5772"
                        y2="-4.1929"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_4_)"
                        d="M26.5,3C26.776,3,27,2.776,27,2.5S26.776,2,26.5,2h-11C15.224,2,15,2.224,15,2.5S15.224,3,15.5,3
                              H26.5z"
                      />
                      <linearGradient
                        id="SVGID_5_"
                        gradientUnits="userSpaceOnUse"
                        x1="-2.9557"
                        y1="9.1407"
                        x2="35.2526"
                        y2="-7.2759"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_5_)"
                        d="M13,4.5v-4C13,0.224,12.776,0,12.5,0S12,0.224,12,0.5v4C12,4.776,12.224,5,12.5,5S13,4.776,13,4.5z"
                      />
                      <linearGradient
                        id="SVGID_6_"
                        gradientUnits="userSpaceOnUse"
                        x1="-0.3065"
                        y1="15.3067"
                        x2="37.9019"
                        y2="-1.11"
                      >
                        <stop offset="0" style={{ stopColor: "#e7a73b" }} />
                        <stop offset="1" style={{ stopColor: "#e7a73b" }} />
                      </linearGradient>
                      <path
                        fill="url(#SVGID_6_)"
                        d="M29.5,5C29.776,5,30,4.776,30,4.5v-4C30,0.224,29.776,0,29.5,0S29,0.224,29,0.5v4
                              C29,4.776,29.224,5,29.5,5z"
                      />
                    </svg>
                    <span style={{ marginLeft: 40 }}>
                      <strong>{activeDay}</strong>
                      <span> - {dayDateMap[activeDay]}</span>
                    </span>
                  </div>
                </div>
              </li>

              {schedule[activeDay]?.map((session, index) => (
                <li key={index} className="active">
                  <div
                    className="block-detail"
                    style={{ borderBottom: "1px solid #444444" }}
                  >
                    <span className="time">{session.time}</span>
                    <span className="topic">{session.topic}</span>

                    {session.venue && (
                      <div className="block-text">
                        <span className="custom-speaker-label">Venue:</span>
                        {session.venue.map((item, i) => {
                          // Resolve link from string | array | object
                          let raw =
                            typeof session.link === "string"
                              ? session.link
                              : Array.isArray(session.link)
                              ? session.link[i]
                              : session.link && typeof session.link === "object"
                              ? session.link[item] || session.link
                              : null;

                          // Ensure full URL
                          const venueLink =
                            raw && typeof raw === "string"
                              ? raw.startsWith("http://") ||
                                raw.startsWith("https://")
                                ? raw
                                : `https://${raw}`
                              : null;

                          if (venueLink) {
                            return (
                              <a
                                key={i}
                                href={venueLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="custom-gradient-text"
                                style={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  // Optional: debug what we’re opening
                                  // console.log("Opening venue link:", venueLink);
                                }}
                              >
                                {item}
                              </a>
                            );
                          }

                          return (
                            <span key={i} className="custom-gradient-text">
                              {item}
                            </span>
                          );
                        })}
                      </div>
                    )}

                    {session.location && (
                      <div className="block-text">
                        <span className="custom-speaker-label">Location:</span>
                        {session.location.map((item, i) => {
                          if (item.includes("Emirates Hills")) {
                            return (
                              <a
                                key={i}
                                href="#gala-dinner"
                                className="custom-gradient-text"
                                style={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  const galaSection =
                                    document.querySelector("#gala-dinner");
                                  if (galaSection) {
                                    galaSection.scrollIntoView({
                                      behavior: "smooth",
                                    });
                                  }
                                }}
                              >
                                {item}
                              </a>
                            );
                          }

                          return (
                            <span key={i} className="custom-gradient-text">
                              {item}
                            </span>
                          );
                        })}
                      </div>
                    )}

                    {((session.about && session.about.length > 0) ||
                      session.speaker) && (
                      <div className="block-text">
                        {session.about && session.about.length > 0 && (
                          <ul className="custom-session-about improved-indent">
                            {session.about.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        )}

                        {session.speaker && session.speaker.length > 0 && (
                          <div className="custom-session-speaker">
                            <span className="custom-speaker-label">
                              {session.speaker.length > 1
                                ? "Speakers:"
                                : "Speaker:"}
                            </span>
                            <ul className="custom-speaker-list">
                              {session.speaker.map((speaker, i) => {
                                const match = speaker.match(
                                  // eslint-disable-next-line no-useless-escape
                                  /^([\d:\s–\-]+(?:\([^)]+\))?)\s*-\s*(.+?)\s*-\s*(.+)$/
                                );

                                if (match) {
                                  const [, time, name, title] = match;
                                  return (
                                    <li key={i}>
                                      <div className="speaker-line">
                                        <span className="speaker-time-stamp">
                                          {time.trim()}
                                        </span>
                                        <span className="speaker-name">
                                          {name} – {title}
                                        </span>
                                      </div>
                                    </li>
                                  );
                                }

                                return (
                                  <li key={i}>
                                    <div className="speaker-line">
                                      <span className="speaker-name">
                                        {speaker}
                                      </span>
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        )}

                        {/* Moderator FIRST */}
                        {session.moderator?.length ? (
                          <div className="custom-session-speaker">
                            <span className="custom-speaker-label">
                              {session.moderator.length > 1
                                ? "Moderators:"
                                : "Moderator:"}
                            </span>{" "}
                            {session.moderator.map((m, i) => (
                              <span key={i} className="custom-gradient-text">
                                {m}
                              </span>
                            ))}
                          </div>
                        ) : null}

                        {session.fireside && session.fireside.length > 0 && (
                          <div className="custom-session-speaker">
                            <span className="custom-speaker-label">
                              Fireside Discussion:
                            </span>{" "}
                            {session.fireside!.map((speaker, i) => (
                              <span key={i} className="custom-gradient-text">
                                {speaker}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScheduleSection;
